import type { NextSeoProps } from 'next-seo/pages';

import { resize } from '#utils/image/resize';

import { ensureArticleUrlIncludesRowId } from '../articles/ensureArticleUrlIncludesRowId';
import { getImageAltText, getImageUrl } from '../image';

import type { BuildArticleSeoConfigFragment } from './__generated__/buildArticleSeoConfig.generated';
import { buildOpenGraphObject } from './buildOpenGraphObject';
import { defaultImage } from './schema-org/constants';

export function buildArticleSeoConfig(article: BuildArticleSeoConfigFragment, selfOrigin: string): NextSeoProps {
	const teaserImage = getImageUrl(article.image) || defaultImage(selfOrigin).url?.toString();
	const teaserImageAltText = getImageAltText({ image: article.image, seoTitle: article.seoTitle, title: article.title }) || '';
	const teaserImageResized = teaserImage ? resize(teaserImage, 'landscape', 'xxl') : undefined;

	const openGraph = buildOpenGraphObject({
		description: article.teaserText,
		image: teaserImageResized,
		imageAlt: teaserImageAltText,
		imageHeight: 900,
		imageWidth: 1600,
		seoTitle: article.seoTitle,
		title: article.title,
		type: 'article',
		url: article.shareUrl,
	});

	const canonicalUrl = typeof article.canonicalUrl === 'string' && article.canonicalUrl.trim() !== '' ? article.canonicalUrl : undefined;

	return {
		canonical: canonicalUrl ?? ensureArticleUrlIncludesRowId(article.shareUrl, article.rowId),
		description: article.teaserText || undefined,
		openGraph,
		title: article.title,
		robotsProps: { maxImagePreview: 'large' },
	};
}
